import {ModuleConfiguration} from "../router/model/UserPermission";
import {BranchServiceModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const BranchServiceModuleConfiguration = new ModuleConfiguration(
    BranchServiceModuleName,
    [AngularJsMaterialModuleName]
);